
import { fetchPermissions, fetchNotificationsListing  } from "../redux";
import store from '../redux/store';
import { checkSession } from "./CheckSessionService";
import { socketDisconnect } from "./SocketServices";
import history from "../utils/history";
import swal from "sweetalert";

export const updateNotificationsCount = () => {

    if(checkSession()){
        store.store.dispatch(fetchNotificationsListing());
    }

}

export const logoutUser = () => {
    swal("Your system access has been revoked! You'll will be logged out.", {
        className: "autologout-swal-modal",
      });
      setTimeout(() => {
        localStorage.clear("USER_INFO");
        socketDisconnect();
        history.push("/");
      }, 2000);
}



